import React from 'react';
import { Sparklines, SparklinesLine } from 'react-sparklines';

function TableItem({ name, icon, data, sparklineData }) {
    return (
        <div className='table__row'>
            <div className='table__item' data-label='Markets'>
                <img src={icon} alt={name} style={{ width: 30, height: 30 }} />
                {name}
            </div>
            <div className='table__item' data-label='Price'>
                {data ? `${data.price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })} USD` : 'Loading...'}
            </div>
            <div className='table__item' data-label='Change %'>
                <div className={`table__change ${data?.change > 0 ? 'positive' : 'negative'}`}>
                    {data ? `${data.change?.toFixed(2)}%` : 'Loading...'}
                </div>
            </div>
            <div className='table__item' data-label='Market cap'>
                {data ? `${(data.marketCap )?.toFixed(3)}T` : 'Loading...'}
            </div>
            <div className='table__item' data-label='Volume 24h'>
                {data ? `${(data.volume )?.toFixed(3)}B` : 'Loading...'}
            </div>
            {/*<div className='table__item' data-label='Circ supply'>*/}
            {/*    {data ? `${(data.circulatingSupply / 1e6)?.toFixed(3)}M` : 'Loading...'}*/}
            {/*</div>*/}
            <div className='table__item' data-label='Rate'>
                <Sparklines data={sparklineData || []} width={80} height={30} margin={5}>
                    <SparklinesLine style={{ fill: 'none' }} color="orange" />
                </Sparklines>
            </div>
        </div>
    );
}

export default TableItem;
